import React from "react";
import "./style.css";
export default function Stars({ isActive }) {
  return (
    <li className="star-li">
      <i className={`${isActive ? "fas" : "far"} fa-star`}></i>
    </li>
  );
}
